// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"a32fe7c4","488":"64f643b4","653":"48ada930","762":"4c186ba7"}[chunkId] + ".chunk.js";
};